// extracted by mini-css-extract-plugin
export var hidden = "_uc-0";